module.exports = __webpack_public_path__ + "img/main-checked.add8b829.svg";